import {periodStateActions} from '../../const/actionType';

export const setPeriods = (periods) => ({
  type: periodStateActions.SET_PERIODS,
  periods,
});

export const setSelectedPeriod = (selected) => ({
  type: periodStateActions.SET_SELECTED_PERIOD,
  selected,
});

export const resetSelectedPeriod = () => ({
  type: periodStateActions.RESET_SELECTED_PERIOD,
});
